export const CONTENT_TYPE = 'application/json';
export const SORT_DIRECTION = 'ASC';
export const SORT_FIELD = 'serviceOfferCode';
